import type {ListSupplierFunctionsSearch} from "./-types";

import {listSupplierFunctionsQueryOptions} from "@project/application/engineering/supplier-functions";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {SupplierFunctionsPage} from "./-page/supplier-functions.page";
import {SupplierFunctionsPending} from "./-page/supplier-functions.pending";
import {listSupplierFunctionsSearchSchema} from "./-types";

export type {ListSupplierFunctionsSearch} from "./-types";

export const Route = createFileRoute("/_app/engineering/suppliers/functions/")({
  component: SupplierFunctionsPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(
        listSupplierFunctionsQueryOptions(deps as ListSupplierFunctionsSearch),
      );
    }

    void queryClient.prefetchQuery(
      listSupplierFunctionsQueryOptions(deps as ListSupplierFunctionsSearch),
    );

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: SupplierFunctionsPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listSupplierFunctionsSearchSchema.parse(search),
});
